import { unzip as fflateUnzip } from "fflate";
import JSZip from "jszip";

// Every caller passes the `ArrayBuffer` body of a `responseType: "arraybuffer"` axios response;
// both branches below (`new Uint8Array` and JSZip `loadAsync`) accept that directly.
export async function unzip(zippedData: ArrayBuffer, isJson = true, signal?: AbortSignal) {
  if (signal?.aborted) {
    throw new DOMException("Aborted", "AbortError");
  }
  if (isJson) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      fflateUnzip(new Uint8Array(zippedData), async (err, files) => {
        if (err) {
          return reject(err);
        }
        if (signal?.aborted) {
          return reject(new DOMException("Aborted", "AbortError"));
        }

        const worker = new Worker(new URL("./jsonParserWorker.js", import.meta.url), {
          type: "module",
        });

        const onAbort = () => {
          worker.terminate();
          reject(new DOMException("Aborted", "AbortError"));
        };
        signal?.addEventListener("abort", onAbort, { once: true });

        worker.postMessage(files["data"]);

        worker.onmessage = (event) => {
          signal?.removeEventListener("abort", onAbort);
          if (event.data.error) {
            worker.terminate();
            reject(event.data.error);
          } else {
            worker.terminate();
            resolve(event.data.result);
          }
        };

        worker.onerror = (error) => {
          signal?.removeEventListener("abort", onAbort);
          worker.terminate();
          reject(`Worker error: ${error.message}`);
        };
      });
    });
  } else {
    const zip = new JSZip();
    const loadedZip = await zip.loadAsync(zippedData);
    const file = Object.values(loadedZip.files)[0];

    const fileContent = await file?.async("uint8array");
    const base64String = new TextDecoder().decode(fileContent);

    return base64String;
  }
}
